import { wrapCall, callGet, callPost, callDeleteWithBody } from './helpers'

// Gets tags in the system
export const getTags = async () => {
  return await wrapCall({ method: callGet, uri: '/tags' })
}

// Uploads a tag to the system
export const postTag = async tag => {
  return await wrapCall({ method: callPost, uri: '/tags', data: { tag } })
}

// Uploads a tag to the system
export const deleteTag = async tag => {
  return await wrapCall({
    method: callDeleteWithBody,
    uri: '/tags',
    data: { tag }
  })
}
